import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/hooks";
import { userActions } from "../../store/user";

const ReferralHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");

    if (ref) {
      localStorage.setItem("referral_code", ref.slice(-8));
    }

    dispatch(userActions.signUpModal({visible:true}));

    navigate("/", { replace: true });
  }, [dispatch, location.search, navigate]);

  return null;
};

export default ReferralHandler;
